import { render } from "./DeliveryReport.vue?vue&type=template&id=669a4d0e&scoped=true"
import script from "./DeliveryReport.vue?vue&type=script&lang=js"
export * from "./DeliveryReport.vue?vue&type=script&lang=js"

import "./DeliveryReport.vue?vue&type=style&index=0&id=669a4d0e&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-669a4d0e"]])

export default __exports__